import { io } from 'socket.io-client';

// Funzione per determinare l'URL del socket
const getSocketURL = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:4000';
  }
  return `http://${window.location.hostname}:4000`;
};

let socketInstance = null;

try {
  // Inizializza Socket.IO con gestione degli errori
  socketInstance = io(getSocketURL(), {
    transports: ['websocket', 'polling'],
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    autoConnect: true
  });

  // Gestione eventi di connessione
  socketInstance.on('connect', () => {});

  socketInstance.on('connect_error', (error) => {});

  socketInstance.on('disconnect', (reason) => {});
} catch (error) {
  // Errore nella creazione dell'istanza Socket.IO
}

// Crea un oggetto dummy se l'inizializzazione fallisce
const socket = socketInstance || {
  on: () => {},
  off: () => {},
  emit: () => {}
};

export default socket;